import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import Solutions from './components/Solutions';
import TechUniverse from './components/TechUniverse';
import UseCases from './components/UseCases';
import WhyWotech from './components/WhyWotech';
import Testimonials from './components/Testimonials';
import ContactForm from './components/ContactForm';
import Footer from './components/Footer';
import SEOHead from '../../components/SEOHead';

const HomePage = () => {
  const schema = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": "WOTECH - ManageEngine Partner Türkiye | IT Çözümleri AutomMate Zoho ONE",
    "description": "WOTECH - ManageEngine, AutomMate ve Zoho ONE Türkiye Partneri. ITSM, UEM, Active Directory yönetimi, otomasyon ve entegrasyon çözümleri. 12+ yıl deneyim, 400+ proje.",
    "inLanguage": "tr-TR",
    "isPartOf": {
      "@type": "WebSite",
      "name": "WOTECH",
      "url": import.meta.env.VITE_SITE_URL || 'https://wotech.tr'
    },
    "about": {
      "@type": "ProfessionalService",
      "name": "WOTECH",
      "serviceType": [
        "IT Danışmanlığı",
        "ManageEngine Entegrasyonu",
        "ITSM Çözümleri",
        "UEM Çözümleri",
        "IT Otomasyon",
        "Zoho ONE Implementasyonu",
        "Active Directory Yönetimi"
      ],
      "areaServed": "TR",
      "provider": {
        "@type": "Organization",
        "name": "WOTECH"
      }
    },
    "breadcrumb": {
      "@type": "BreadcrumbList",
      "itemListElement": [
        {
          "@type": "ListItem",
          "position": 1,
          "name": "Ana Sayfa",
          "item": import.meta.env.VITE_SITE_URL || 'https://wotech.tr'
        }
      ]
    }
  };

  return (
    <>
      <SEOHead
        title="Türkiye ManageEngine Partner WOTECH | IT Çözümleri AutomMate Zoho ONE"
        description="WOTECH - ManageEngine, AutomMate ve Zoho ONE Türkiye Partneri. ITSM, UEM, Active Directory yönetimi, otomasyon ve entegrasyon çözümleri. 12+ yıl deneyim, 400+ proje. Kurumsal IT çözümlerinde güvenilir partner."
        keywords="ManageEngine Partner, AutomMate Türkiye, Zoho ONE, ITSM, ServiceDesk Plus, Endpoint Central, Active Directory, IT otomasyon, kurumsal IT çözümleri"
        ogTitle="WOTECH - ManageEngine ve AutomMate Türkiye Partneri"
        ogDescription="Kurumsal IT çözümlerinde 12+ yıl deneyim. ManageEngine, AutomMate, Zoho ONE uzmanı."
        canonical="/"
        schema={schema}
      />
      <main className="min-h-screen bg-white">
        <Navbar />
        <Hero />
        <About />
        <Solutions />
        <TechUniverse />
        <UseCases />
        <section id="why">
          <WhyWotech />
        </section>
        <Testimonials />
        <ContactForm />
        <Footer />
      </main>
    </>
  );
};

export default HomePage;
